import React from 'react';

export const IconJustin = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 5.2353V20.2941C21 20.4813 20.9256 20.6609 20.7933 20.7933C20.6609 20.9256 20.4813 21 20.2941 21H5.2353C5.04809 21 4.86855 20.9256 4.73617 20.7933C4.60379 20.6609 4.52942 20.4813 4.52942 20.2941V5.2353C4.52942 5.04809 4.60379 4.86855 4.73617 4.73617C4.86855 4.60379 5.04809 4.52942 5.2353 4.52942H20.2941C20.4813 4.52942 20.6609 4.60379 20.7933 4.73617C20.9256 4.86855 21 5.04809 21 5.2353Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4706 1H1.70588C1.51867 1 1.33913 1.07437 1.20675 1.20675C1.07437 1.33913 1 1.51867 1 1.70588V17.4706M11.4812 9.87647C11.374 9.81209 11.2517 9.77732 11.1267 9.77572C11.0017 9.77412 10.8785 9.80576 10.7697 9.86738C10.6609 9.92901 10.5705 10.0184 10.5076 10.1265C10.4447 10.2345 10.4116 10.3573 10.4118 10.4824V15.0471C10.4116 15.1721 10.4447 15.2949 10.5076 15.4029C10.5705 15.511 10.6609 15.6004 10.7697 15.662C10.8785 15.7237 11.0017 15.7553 11.1267 15.7537C11.2517 15.7521 11.374 15.7173 11.4812 15.6529L15.2847 13.3706C15.3895 13.3079 15.4763 13.2192 15.5365 13.113C15.5967 13.0068 15.6284 12.8868 15.6284 12.7647C15.6284 12.6426 15.5967 12.5226 15.5365 12.4164C15.4763 12.3102 15.3895 12.2215 15.2847 12.1588L11.4812 9.87647Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
